import { section } from "@/glow";
import { qs, listen } from "@fluorescent/dom";
import { animateStandard, shouldAnimate } from "@/lib/animation";

const selectors = {
  collectionListInner: ".collection-list__inner",
  expandButton: ".collection-list__expand-button",
};

section("collection-list", {
  onLoad() {
    const expandButton = qs(selectors.expandButton, this.container);
    const collectionListInner = qs(
      selectors.collectionListInner,
      this.container
    );

    this.events = [];

    if (expandButton) {
      this.events.push(
        listen(expandButton, "click", e => {
          e.preventDefault();
          collectionListInner.dataset.expanded = true;
        })
      );
    }

    if (shouldAnimate(this.container)) {
      this.animateCollectionList = animateStandard(this.container);
    }
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
    this.animateCollectionList?.destroy();
  },
});
